export default __webpack_public_path__ + "static/media/todo.d9b1cd8e.jpg";